


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Organization } from '@/interfaces/registration/Organization';
import api from '@/api/registration';
import lodash from 'lodash';

@Component
export default class FormOrganizationInput extends Vue {
  @Prop({ default: 'Search organizations ...' }) readonly placeholder!: string;
  @Prop({ default: 'Name' }) readonly label!: string;
  @Prop() readonly autocompleteUrl!: string;
  @Prop({ default: 2 }) readonly minLength!: number;

  $refs!: {
    inputElement: HTMLFormElement;
  };

  public newOrganizationName = '';

  public organizations: Array<Organization> = [];

  public selectedOrganizationIndex = -1;

  public showSelector = false;

  public focusInput (): void {
    this.$refs.inputElement.focus();
  }

  public nextOrganization () {
    if (this.organizations.length > 0 && this.organizations.length > (this.selectedOrganizationIndex + 1)) {
      this.selectedOrganizationIndex++;
      this.newOrganizationName = this.organizations[this.selectedOrganizationIndex].name as string;
    }
  }

  public prevOrganization () {
    if (this.selectedOrganizationIndex > 0) {
      this.selectedOrganizationIndex--;
      this.newOrganizationName = this.organizations[this.selectedOrganizationIndex].name as string;
    }
  }

  public onInput (): void {
    if (this.newOrganizationName.length >= this.minLength) {
      this.selectedOrganizationIndex = -1;
      api.get(this.autocompleteUrl, { params: { term: this.newOrganizationName } })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.organizations = lodash.map(response.data, (item) => {
              return {
                id: item.Id,
                name: item.Name
              };
            });
          } else {
            this.organizations = [{
              id: 0,
              name: this.newOrganizationName
            }];
          }
          this.showSelector = true;
        });
    }
  }

  public selectFromList (index: number): void {
    this.selectedOrganizationIndex = index;
    this.selectOrganization(true);
  }

  public selectOrganization (add: boolean): void {
    if (this.selectedOrganizationIndex === -1) {
      this.selectedOrganizationIndex = 0;
    }

    if (add) {
      this.addEducation();
    }

    this.showSelector = false;
  }

  public addEducation (): void {
    if (this.selectedOrganizationIndex !== -1) {
      this.$emit('add', this.organizations[this.selectedOrganizationIndex]);
      this.newOrganizationName = '';
      this.selectedOrganizationIndex = -1;
      this.organizations = [];
    }
  }

  get showAutcomplete (): boolean {
    return this.organizations.length > 0 && this.showSelector;
  }
}
